export const add = "ADD"
export const remove = "REMOVE"
export const clear = "CLEAR"
export const plusQantity = "PLUSQUANTİTY"
export const minusQuantity = "MİNUSQUANTİTY"
